import { apiAction } from "../models/requests";
import { USER_ID} from "../constants/Constants";

const appendTokenName = (data) => {
    return data;
};

export function getUser() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user = {"user_id": USER_ID};   
    appendTokenName(data); 
    return apiAction({
        types: ["GET_USER_REQUESTED", "GET_USER_SUCCESS", "GET_USER_FAILED"],
        method: "POST",
        path: "get_user",
        body: data
    });
}

export function getUserAttributes() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_USER_ATTRIBUTES_REQUESTED", "GET_USER_ATTRIBUTES_SUCCESS", "GET_USER_ATTRIBUTES_FAILED"],
        method: "POST",
        path: "get_user_attributes",
        body: data
    });
}

export function updateUserAttribute(target_user_attributes) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user_attributes = target_user_attributes;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_USER_ATTRIBUTES_REQUESTED", "UPDATE_USER_ATTRIBUTES_SUCCESS", "UPDATE_USER_ATTRIBUTES_FAILED"],
        method: "POST",
        path: "update_user_attribute",
        body: data
    });
}

export function setUserPassword(password) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.current_password = password.password,
    data.new_password =  password.confirmPassword;
    data.set_two_factor = password.set_two_factor;
    appendTokenName(data); 
    return apiAction({
        types: ["SET_USER_PASSWORD_REQUESTED", "SET_USER_PASSWORD_SUCCESS", "SET_USER_PASSWORD_FAILED"],
        method: "POST",
        path: "set_password",
        body: data
    });
}

export function getUserUsageDump() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_USAGE_DUMP_REQUESTED", "GET_USAGE_DUMP_SUCCESS", "GET_USAGE_DUMP_FAILED"],
        method: "POST",
        path: "get_usage_details",
        body: data
    });
}

export function getUserUsageSummary() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_USAGE_SUMMARY_REQUESTED", "GET_USAGE_SUMMARY_SUCCESS", "GET_USAGE_SUMMARY_FAILED"],
        method: "POST",
        path: "get_usage_summary",
        body: data
    });
}

export function getSubscriptionInfo() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SUBSCRIPTION_INFO_REQUESTED", "GET_SUBSCRIPTION_INFO_SUCCESS", "GET_SUBSCRIPTION_INFO_FAILED"],
        method: "POST",
        path: "subscription_info",
        body: data
    });
}

export function cancelSubscription() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["CANCEL_SUBSCRIPTION_REQUESTED", "CANCEL_SUBSCRIPTION_SUCCESS", "CANCEL_SUBSCRIPTION_FAILED"],
        method: "POST",
        path: "cancel_subscription",
        body: data
    });
}

export function getAllProducts() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_PRODUCTS_REQUESTED", "GET_PRODUCTS_SUCCESS", "GET_PRODUCTS_FAILED"],
        method: "POST",
        path: "subscriptions/getProducts",
        body: data
    });
}

export function updateSubscription(planData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = planData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_SUBSCRIPTION_REQUESTED", "UPDATE_SUBSCRIPTION_SUCCESS", "UPDATE_SUBSCRIPTION_FAILED"],
        method: "POST",
        path: "update_subscription",
        body: data
    });
}

export function updatePayment() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_PAYMENT_REQUESTED", "UPDATE_PAYMENT_SUCCESS", "UPDATE_PAYMENT_FAILED"],
        method: "POST",
        path: "update_payment",
        body: data
    });
}

export function renewSubscription() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["RENEW_SUBSCRIPTION_REQUESTED", "RENEW_SUBSCRIPTION_SUCCESS", "RENEW_SUBSCRIPTION_FAILED"],
        method: "POST",
        path: "renew_subscription",
        body: data
    });
}

export function createSubscription(planData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = planData;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_SUBSCRIPTION_REQUESTED", "CREATE_SUBSCRIPTION_SUCCESS", "CREATE_SUBSCRIPTION_FAILED"],
        method: "POST",
        path: "create_subscription",
        body: data
    });
}
export function setUsagePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_USAGE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}
export function setAdminUsagePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_ADMIN_USAGE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}
export function setUserProfilePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_USER_PROFILE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}


// WEBPACK FOOTER //
// ./src/actions/actionUser.js